import PatientEditionPage from '@/pages/PatientEditionPage/PatientEditionPage.vue'

export default PatientEditionPage
